import Dexie from "dexie";
import { IDatabaseUpgrade } from "../database-upgrade";
import { StoredDispatchedServiceSyncData } from "src/app/driver/storage/models/stored-dispatched-service-sync-data";

/**
 * Defines the upgrade path for version 8 of indexed DB.
 */
export class DatabaseUpgradeV8 implements IDatabaseUpgrade {
	/** @inheritdoc */
	public readonly Version: number = 8;

	/** @inheritdoc */
	public Upgrade(dexieInstance: Dexie): void {
		dexieInstance.version(this.Version).stores({
			DispatchedServiceDocuments: "Id, UserName, CrownId, ServiceId, CreatedDate"
		});
	}
}